export default __webpack_public_path__ + "static/media/1326.c715b244.png";